import { useState, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import RootContext from './context/RootContext';
import AppRoutes from './routes/AppRoutes';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './index.css';
import SessionManager from './components/SessionManager';
import useDetectDevTools from './hooks/useDetectDevTools';


function App() {
  // Use Context State
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState();
  useDetectDevTools();

  const getFullYear = () => {
    setYear(new Date().getFullYear());
  };

  useEffect(() => {
    getFullYear();
  }, []);

  return (
    <BrowserRouter>
      <RootContext.Provider
        value={{
          loading,
          setLoading,
          year,
        }}
      >
         <SessionManager />
        <AppRoutes />
      </RootContext.Provider>
    </BrowserRouter>
  );
}

export default App;
